import {
	getUser,
	updateUser,
	getDateTimes,
	getLanguages,
	deleteAccount,
	activateAccount,
	deactivateAccount,
	getCurrencies,
} from '../../../api';
import { onRequest } from '../..';
import { PropertyType, ActionsType } from '../../../common';

const userStore = async (user: PropertyType) => {
	const { id, username, isActive, lastActivity, activeLanguage, activeDateTime, activeCurrency, defaults } = user;
	const { dateTimes } = await getDateTimes();
	const { languages } = await getLanguages();
	const { currencies } = await getCurrencies();

	return {
		userId: id,
		username,
		isActive,
		lastActivity,
		currencies,
		activeCurrency,
		languages,
		activeLanguage,
		dateTimes,
		activeDateTime,
		defaults,
	};
};

const userInit = async (payload: PropertyType) => {
	const { token, id } = payload;
	const user = await getUser({ token, uid: id });

	return userStore(user);
};

const settingsSubmit = async (state: PropertyType, token: string) => {
	const success = await updateUser({ token, ...state });

	return { errors: [], success };
};

const resetToDefaultSubmit = async (state: PropertyType, token: string) => {
	const { language, dateTime } = state.defaults;
	const success = await updateUser({
		token,
		...state,
		activeLanguage: language,
		activeDateTime: dateTime,
	});

	return {
		activeLanguage: language,
		activeDateTime: dateTime,
		errors: [],
		success: success,
	};
};

const onAccountDelete = async (state: PropertyType, token: string) => {
	const success = await deleteAccount({
		token,
		...state,
		userIds: [state.userId],
	});

	return { errors: [], success };
};

const onAccountActivate = async (state: PropertyType, token: string) => {
	const success = await activateAccount({
		token,
		...state,
		userIds: [state.userId],
	});

	return { errors: [], success };
};

const onAccountDeactivate = async (state: PropertyType, token: string) => {
	const success = await deactivateAccount({
		token,
		...state,
		userIds: [state.userId],
	});

	return { errors: [], success };
};

export const actions: ActionsType = {
	LANGUAGE: (state, payload) => ({ activeLanguage: payload }),
	DATE_TIME: (state, payload) => ({ activeDateTime: payload }),
	CURRENCY: (state, payload) => ({ activeCurrency: payload }),
	ERROR: (state, payload) => ({ errors: payload }),
	SUCCESS: (state, payload) => ({ success: payload }),
	USER_INIT: (state, payload) => onRequest(() => userInit(payload)),
	SETTINGS_SUBMIT: (state, payload) => onRequest(() => settingsSubmit(state, payload)),
	RESET_TO_DEFAULT_SUBMIT: (state, payload) => onRequest(() => resetToDefaultSubmit(state, payload)),
	DELETE_ACCOUNT: (state, payload) => onRequest(() => onAccountDelete(state, payload)),
	ACTIVATE_ACCOUNT: (state, payload) => onRequest(() => onAccountActivate(state, payload)),
	DEACTIVATE_ACCOUNT: (state, payload) => onRequest(() => onAccountDeactivate(state, payload)),
	MESSAGE_INVALIDATE: () => ({ errors: [], success: '' }),
};
